import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';
import { routes } from '@/routes';

export const useTransmissionReportFeature = () => {
  const isTransmissionReportPageEnabled = useFeatureFlag('new-tx-report-page-v2');

  const getDefaultReportRoute = () => {
    return isTransmissionReportPageEnabled
      ? routes.physician.defaultTransmissionReport
      : routes.physician.reviewTransmissions;
  };

  const getSpecificReportRoute = (id: string) => {
    return isTransmissionReportPageEnabled
      ? routes.physician.transmissionReportDetail(id)
      : routes.physician.reviewTransmission(id);
  };

  return {
    isTransmissionReportPageEnabled,
    getDefaultReportRoute,
    getSpecificReportRoute
  };
};
